module.exports = __webpack_public_path__ + "static/media/trawlo.b3afeb90.svg";